import moment from "moment";

import { Button } from "react-bootstrap";

function MyDatePresets(props) {
  const { startDate, endDate, displayFormat, handlePresets } = props;

  const presets = [
    {
      text: "Danes",
      trText: "Danes",
      start: moment().startOf("day"),
      end: moment().endOf("day"),
    },
    {
      text: "Prejšnji teden",
      trText: "Prejšnji teden",
      start: moment().subtract(1, "weeks").startOf("week"),
      end: moment().subtract(1, "weeks").endOf("week"),
    },
    {
      text: "Prejšnji mesec",
      trText: "Prejšnji mesec",
      start: moment().subtract(1, "months").startOf("month"),
      end: moment().subtract(1, "months").endOf("month"),
    },
  ];

  return (
    <div>
      {" "}
      <div className="btn-wrap text-center" style={{ textAlign: "center" }}>
        {presets.map(({ text, start, end }) => {
          const isSelected =
            moment(start).format(displayFormat) ===
              moment(startDate).format(displayFormat) &&
            moment(end).format(displayFormat) ===
              moment(endDate).format(displayFormat);
          console.log(start, end);
          return (
            <Button
              key={text}
              type="button"
              className={"btn btn-datePicker"}
              style={{ marginRight: 10 }}
              onClick={() => handlePresets(start, end)}
            >
              {text}
            </Button>
          );
        })}
      </div>
    </div>
  );
}

export default MyDatePresets;
